<template>
  <section>
    <Header title="Commands" />
    <div class="info-page-loader" v-if="!categories.length"><div class="page-pulse"><div></div><div></div><div></div></div></div>
    <div class="commands-row">
      <CommandCategory 
        v-for="(category, cIndex) in categories" v-bind:key="category.name" 
        v-bind:category="category"
        v-bind:previousLength="categories[cIndex-1]?categories[cIndex-1].commands.length : 0"
        v-bind:cIndex="cIndex"
      />
    </div>
    <Cookie />
    <Footer v-bind:shown="!categories.length" />
  </section>
</template>

<script>
// @ is an alias to /src
import CommandCategory from "@/components/CommandCategory.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Cookie from "@/components/Cookie.vue";

export default {
  name: "Commands",
  components: {
    CommandCategory,
    Header,
    Footer,
    Cookie
  },
  data () {
    return {
      categories: []
    }
  },
  methods: {
    fetchCommands: async function () {
      const cats = await this.$axios.get(`${this.$apiBase}/v1/commands/list`);
      const categories = cats.data.data;
      this.categories = categories.filter(c => c.name != "_Owner");
    }
  },
  mounted () {
    this.fetchCommands();
  }
}
</script>

<style scoped>
  .commands-row {
    text-align: center;
    justify-content: center;
    transition: .5s;
  }
</style>